export default __webpack_public_path__ + "static/crazy-technology-746eef4acdd451b0e25d64569378eb4d.jpg";